export default __webpack_public_path__ + "static/media/dependant.cbefe01d.svg";